import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import {IExpressOrder} from 'plugins/modules/filter/types';
import React, {FC, ReactNode, useCallback, useEffect, useMemo, useState} from 'react';
import {IDetectedCity} from 'modules/locations/models';
import {LocationService} from 'modules/locations/services/LocationService';
import {useGetExpressOrderQuery} from 'modules/products/services';
import {useSyncExpressOrderStoreCookie} from 'modules/express-order/hooks/useSyncExpressOrderStoreCookie';

interface IProps {
    children: ReactNode;
}

const locationService = new LocationService();

export const FilterPickupTodayButtonProvider: FC<IProps> = ({children}) => {
    const [cityData, setCityData] = useState<IDetectedCity>();
    const [wineShop, setWineShop] = useState<IExpressOrder>();
    const [handleResetPagination, setHandleResetPagination] = useState<() => void>(() => {});

    const expressOrderResponse = useGetExpressOrderQuery();

    useSyncExpressOrderStoreCookie();

    const detectCity = useCallback(async () => {
        try {
            const {default: defaultCity, supposed} = await locationService.detectCity();

            if (!supposed) {
                setCityData(defaultCity);

                return;
            }

            setCityData(supposed);
        } catch (e) {
            console.error(e);
        }
    }, []);

    useEffect(() => {
        let shop = expressOrderResponse?.data?.data;

        if (Array.isArray(shop)) {
            shop = undefined;
        }

        setWineShop(shop);
    }, [expressOrderResponse]);

    useEffect(() => {
        detectCity();
    }, [detectCity]);

    const isShowExpressOrder = !expressOrderResponse?.data?.isHidden;
    const isExpressOrderLoading = expressOrderResponse?.isLoading;

    const value = useMemo(() => {
        return {
            cityData,
            isShowExpressOrder,
            isExpressOrderLoading,
            setWineShop,
            wineShop,
            handleResetPagination,
            setHandleResetPagination,
        };
    }, [cityData, isShowExpressOrder, isExpressOrderLoading, wineShop, handleResetPagination]);

    return <FilterPickupTodayButtonContext.Provider value={value}>{children}</FilterPickupTodayButtonContext.Provider>;
};
